<template>
  <v-form ref="productEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'product-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12"><h1>{{this.id ? 'Редактирование блюда' : 'Создание блюда'}}</h1></v-col>
      <v-col>
        <v-tabs v-model="tab">
          <v-tab>Описание</v-tab>
          <v-tab :disabled="!this.id">Состав</v-tab>
          <v-tab :disabled="!this.id">SEO</v-tab>
          <v-tab :disabled="!this.id">Фотографии</v-tab>
          <v-tab :disabled="!this.id">Быстрый выбор</v-tab>
          <v-tab :disabled="!this.id">Сет</v-tab>
          <v-tab :disabled="!this.id">{{ product.deleted_at ? 'Восстановить' : 'Удалить' }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pt-5">
          <v-tab-item :eager="true">
            <v-row>
              <v-col cols="12" sm="5" md="4" xl="3">
                <v-tabs v-model="tabLang">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabLang">
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field
                                v-model="product.name"
                                label="Название блюда"
                                :rules="[rules.required]"
                                required
                                outlined
                        ></v-text-field>
                        <v-textarea
                                label="Описание"
                                :rules="[rules.required]"
                                required
                                v-model="product.description"
                                rows="5"
                                outlined
                        ></v-textarea>
                        <v-text-field
                            v-model="product.allergen"
                            label="Аллергены"
                            outlined
                        ></v-text-field>
                        <v-textarea
                            v-model="product.die_date"
                            label="Срок годности"
                            rows="3"
                            outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field
                                v-model="product.name_ua"
                                label="Название блюда"
                                :rules="[rules.required]"
                                required
                                outlined
                        ></v-text-field>
                        <v-textarea
                                label="Описание"
                                :rules="[rules.required]"
                                required
                                v-model="product.description_ua"
                                rows="5"
                                outlined
                        ></v-textarea>
                        <v-text-field
                            v-model="product.allergen_ua"
                            label="Аллергены"
                            outlined
                        ></v-text-field>
                        <v-textarea
                            v-model="product.die_date_ua"
                            label="Срок годности"
                            rows="3"
                            outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
                <v-text-field
                        v-model="product.iiko_id"
                        label="Iiko ID"
                        outlined
                ></v-text-field>
                <v-text-field
                    v-model="product.code"
                    label="Iiko Артикул"
                    outlined
                ></v-text-field>
                <v-text-field
                    v-model="product.slug"
                    label="Slug (URL)"
                    outlined
                    hint="Используется в адресной строке"
                >
                  <template #append-outer>
                    <v-btn
                        small
                        text
                        color="primary"
                        @click="generateSlug"
                    >
                      Сгенерировать
                    </v-btn>
                  </template>
                </v-text-field>
                <v-select
                        :items="categories"
                        :item-text="category => category.name"
                        :item-value="category => category.id"
                        v-model="product.parentCategory"
                        label="Категория"
                        outlined
                        :rules="[rules.required]"
                        required
                        return-object
                        @change="updateChildrenCategories"
                ></v-select>
                <v-select
                        :items="childrenCategories"
                        :item-text="category => category.name"
                        :item-value="category => category.id"
                        v-model="product.category"
                        label="Подкатегория"
                        :disabled="childrenCategories.length === 0"
                        outlined
                        return-object
                ></v-select>
                <v-select
                        :items="workshops"
                        :item-text="workshop => workshop.name"
                        :item-value="workshop => workshop"
                        v-model="product.workshop"
                        label="Цех"
                        outlined
                        :rules="rules.requiredSelect"
                        required
                ></v-select>
                <v-select
                        :items="tags"
                        :item-text="tag => tag.name"
                        :item-value="tag => tag.id"
                        v-model="product.tags"
                        label="Теги"
                        chips
                        multiple
                        outlined
                ></v-select>
                <v-row>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field
                            v-model="product.price"
                            :rules="[rules.required]"
                            required
                            label="Цена"
                            suffix="UAH"
                            outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field
                            v-model="product.weight"
                            label="Вес"
                            :rules="[rules.required]"
                            required
                            suffix="g"
                            outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field
                            v-model="product.energy_amount"
                            label="Калории"
                            :rules="[rules.required]"
                            required
                            suffix="ккал"
                            outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field
                            v-model="product.fiber_amount"
                            label="Белки"
                            :rules="[rules.required]"
                            required
                            suffix="g"
                            outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field
                            v-model="product.fat_amount"
                            label="Жиры"
                            :rules="[rules.required]"
                            required
                            suffix="g"
                            outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pt-0 pb-0">
                    <v-text-field
                            v-model="product.carbohydrate_amount"
                            label="Углеводы"
                            :rules="[rules.required]"
                            required
                            suffix="g"
                            outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>Glovo</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-text-field
                          v-model="product.glovo_price"
                          required
                          label="Цена"
                          suffix="UAH"
                          outlined
                      ></v-text-field>
                      <v-text-field
                          v-model="product.glovo_iiko_id"
                          label="Iiko ID"
                          outlined
                      ></v-text-field>
                      <v-text-field
                          v-model="product.glovo_code"
                          label="Iiko Артикул"
                          outlined
                      ></v-text-field>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-checkbox
                        v-model="product.hide"
                        label="Скрыть блюдо"
                ></v-checkbox>
                <v-checkbox
                        v-model="product.is_not_cashback"
                        label="Не начислять кэшбек с этого блюда"
                ></v-checkbox>
                <v-checkbox
                    v-model="product.is_show_reviews"
                    label="Показывать средний рейтинг?"
                ></v-checkbox>
                <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
                <v-btn :loading="loadingButton" v-else @click="create">Создать</v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" class="pt-0">
                <div class="top" v-if="modifiers.length > 0">
                  <modifiers-modal :product-id="product.id" :modifier-categories="modifiers" v-model="product"></modifiers-modal>
                </div>
                <div class="list mt-4">
                    <product-modifiers-table v-model="product" :loading="loading"></product-modifiers-table>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col  cols="12" sm="5" md="4" xl="3">
                <v-tabs v-model="tabLang">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabLang">
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field
                            v-model="product.seo_h1"
                            label="SEO H1"
                            outlined
                        ></v-text-field>
                        <v-text-field
                                v-model="product.seo_title"
                                label="SEO Заголовок"
                                outlined
                        ></v-text-field>
                        <v-textarea
                                v-model="product.seo_description"
                                label="SEO Описание"
                                outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field
                            v-model="product.seo_h1_ua"
                            label="SEO H1"
                            outlined
                        ></v-text-field>
                        <v-text-field
                                v-model="product.seo_title_ua"
                                label="SEO Заголовок"
                                outlined
                        ></v-text-field>
                        <v-textarea
                                v-model="product.seo_description_ua"
                                label="SEO Описание"
                                outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
          </v-tab-item>
          <v-tab-item>
            <v-row class="product-images">
              <v-col cols="12" sm="4">
                  <div class="mb-8">
                    <v-img :src="previewImage(false, backgroundImage)" aspect-ratio="1.6">
                      <template v-slot:placeholder>
                        <div class="image-placeholder"></div>
                      </template>
                    </v-img>
                  </div>
                  <div style="width: 264px; max-width: 100%;">
                    <v-file-input label="Фон в карточку блюда"
                                  prepend-icon=""
                                  outlined
                                  class="cursor-pointer"
                                  v-model="backgroundImage">
                    </v-file-input>
                  </div>
              </v-col>
              <v-col cols="12" sm="1" class="text-center d-none-xs">
                <v-divider vertical></v-divider>
              </v-col>
              <v-col cols="12" sm="3">

                <div class="mb-8">
                  <v-img :src="previewImage(true, listImage)" aspect-ratio="1">
                    <template v-slot:placeholder>
                      <div class="image-placeholder"></div>
                    </template>
                  </v-img>
                </div>
                <div style="width: 264px; max-width: 100%;">
                  <v-file-input label="Картинка в список блюд"
                                prepend-icon=""
                                outlined
                                class="cursor-pointer"
                                v-model="listImage">
                  </v-file-input>
                </div>

              </v-col>
              <v-col cols="12">
              <v-btn :loading="loadingButton" v-if="id" @click="updateImages">Сохранить</v-btn>


              </v-col>


              <hr class="w-full mb-5"/>
              <button class="plus" @click="addMainImage($event)">+ дополнительная картинка</button>

              <v-col cols="12" sm="3"  v-for="(item, index) in additionalMainImages" :key="index">

                <div class="mb-8">
                  <v-img :src="previewImage(true, additionalMainImages[index], true)" aspect-ratio="1">
                    <template v-slot:placeholder>
                      <div class="image-placeholder"></div>
                    </template>
                  </v-img>
                </div>
                <v-file-input :label="'Дополнительная №' + (index+1)"
                              prepend-icon=""
                              outlined
                              class="cursor-pointer"
                              v-model="additionalMainImages[index]">
                </v-file-input>
              </v-col>



            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" sm="12">
                <modifiers-group-modal v-model="product" :modifiers-group="product.modifiers_group" @reloadModifiersGroup="reloadModifiersGroup"></modifiers-group-modal>
                <modifiers-group-table v-model="product.modifiers_group" :disabled="true" for-product :loading="loading"></modifiers-group-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" sm="12">
                <v-autocomplete
                    v-model="product.products_included"
                    :items="setProducts"
                    :loading="setProductsLoading"
                    :search-input.sync="searchSetProducts"
                    multiple
                    hide-no-data
                    chips
                    deletable-chips
                    hide-selected
                    item-text="name"
                    item-value="id"
                    label="Блюдо"
                    outlined
                    return-object
                ></v-autocomplete>
                <v-btn :loading="loadingButton" @click="saveSetProducts">Сохранить</v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" sm="12">
                <div v-if="product.deleted_at">
                  <p>Блюдо удалено: {{ product.deleted_at | formatDate }}</p>
                  <v-btn color="success" :loading="loadingButton" @click="restoreProduct">Восстановить</v-btn>
                </div>
                <div v-else>
                  <p>Блюдо активно</p>
                  <v-btn color="error" :loading="loadingButton" @click="removeProduct">Удалить</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import ProductService from './../../api/ProductService'
  import CategoryService from './../../api/CategoryService'
  import TagService from './../../api/TagService'
  import WorkshopService from './../../api/WorkshopService'
  import ModifierService from "../../api/ModifierService";
  import moment from 'moment'
  import ModifiersModal from "../../components/ModifiersModal";
  import ModifiersGroupModal from "../../components/ModifiersGroupModal";
  import ProductModifiersTable from "../../components/ProductModifiersTable";
  import ModifiersGroupTable from "../../components/ModifiersGroupTable";
  import slugify from '@/utils/slugify'

  export default {
    name: 'ProductEdit',
    props: {
      id: {
        default: null,
      }
    },
    components: {ModifiersModal, ProductModifiersTable, ModifiersGroupTable, ModifiersGroupModal},
    filters: {
      formatDate(value) {
        if (!value) return ''
        return moment(value).format('DD.MM.YYYY HH:mm')
      }
    },
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      childrenCategories: [],
      snackbarColor: '',
      tab: '',
      tabLang: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      sauces: [],
      valid: true,
      setProducts: [],
      setProductsLoading: false,
      searchSetProducts: '',
      product: {
        name: '',
        name_ua: '',
        slug: '',
        description: '',
        description_ua: '',
        category: '',
        allergen: '',
        allergen_ua: '',
        die_date: '',
        die_date_ua: '',
        energy_amount: '',
        fiber_amount: '',
        fat_amount: '',
        carbohydrate_amount: '',
        weight: '',
        price: '',
        glovo_price: '',
        glovo_code: '',
        glovo_iiko_id: '',
        workshop: '',
        is_not_cashback: false,
        is_show_reviews: false,
        tags: '',
        hide: false,
        parentCategory: {
            children: []
        },
        products_included: []
      },
      listImage: null,
      backgroundImage: null,
      additionalBackgroundImages: [],
      additionalMainImages: [],
      loading: true,
      modifiersDialog: false,
      modifierCategories: [],
      modifierTab: null,
      searchModifiers: '',
      modifiers: [],
      loadingButton: false,
      categories: [],
      tags: [],
      workshops: [],
      modifiersGroup: [],
      modal_from: false,
      modal_to: false
    }),
    watch: {
      searchSetProducts (val) {
        if (this.setProductsLoading) return

        this.setProductsLoading = true

        ProductService.findByName({word: this.searchSetProducts}).then(response => {
          this.setProducts = [...response.data, ...this.product.products_included];
        }).finally(response => {
          this.setProductsLoading = false
        });
      },
    },
    mounted() {
      let params = {
        show_disabled: true
      }

      CategoryService.list(params).then(response => {
        this.categories = response.data
        this.init();
      });

      ModifierService.getCategoryList().then(response => {
        this.modifierCategories = response.data
      });

      ModifierService.listGroups().then(response => {
        this.modifiersGroup = response.data
      });

      ModifierService.listByCategory().then(response => {
        this.modifiers = response.data
      });

      WorkshopService.list().then(response => {
        this.workshops = response.data
      });
      TagService.list().then(response => {
        this.tags = response.data
      });
    },
    methods: {

      addMainImage(eve) {
        eve.preventDefault();
        this.additionalMainImages.push(null);
      },

      saveSetProducts(){
        this.loadingButton = true

        let data = {
          ids: []
        }
        this.product.products_included.forEach((item) => {
          data.ids.push(item.id)
        })

        ProductService.updateSetProducts(this.product.id, data).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Блюдо успешно обновлено';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении блюда';
          this.snackbarColor = 'error';
        }).finally(() => (this.loadingButton = false))
      },
      reloadModifiersGroup(){
        ProductService.get(this.id)
            .then(response => {
              this.product.modifiers_group = response.data.modifiers_group

              this.loading = false
            });
      },
      updateChildrenCategories(){
        if(this.categories.length > 0){
          this.childrenCategories = this.categories.find(category => category.id == this.product.parentCategory.id).children
        }

      },
      generateSlug(){
        if(!this.product.name_ua){
          this.snackbar = true;
          this.snackbarText = 'Сначала введите название (UA)';
          this.snackbarColor = 'warning';
          return;
        }

        this.product.slug = slugify(this.product.name_ua);
      },
      validate () {
        this.$refs.productEditForm.validate()

        if(this.product.name == '' && this.product.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.product.name != '' && this.product.name_ua == ''){
          this.tabLang = 1;
        }
      },
      init(){
        if(this.id){
          ProductService.get(this.id)
            .then(response => {
              this.product = response.data;
              if(this.product.main_image){
                this.listImage = this.product.main_image;
                this.listImage.name = this.product.main_image.file
              }

              this.setProducts = this.product.products_included


              if(this.product.background_image){
                this.backgroundImage = this.product.background_image;
                this.backgroundImage.name = this.product.background_image.file
              }

              this.additionalMainImages = [];
              for (const item of this.product.additional_main_images) {
                this.additionalMainImages.push({
                  ...item,
                  name: item.file,
                });
              }

              //console.log(response.data.category.parent.children)
              if(this.categories.length > 0){
                if(this.categories.find(category => category.id == response.data.category.parent_group)){
                  this.childrenCategories = this.categories.find(category => category.id == response.data.category.parent_group).children
                }

              }


              this.product.price = this.product.price == 0 ? '' : this.product.price;
              this.product.energy_amount = this.product.energy_amount == 0 ? '' : this.product.energy_amount;
              this.product.fiber_amount = this.product.fiber_amount == 0 ? '' : this.product.fiber_amount;
              this.product.fat_amount = this.product.fat_amount == 0 ? '' : this.product.fat_amount;
              this.product.carbohydrate_amount = this.product.carbohydrate_amount == 0 ? '' : this.product.carbohydrate_amount;
              this.product.weight = this.product.weight == 0 ? '' : this.product.weight;

              let tags = [];
              this.product.tags.forEach(function (tag) {
                tags.push(tag.id);
              })
              this.product.tags = tags;

              this.serviceCategory();

              this.loading = false
            });
        }
      },
      serviceCategory(){
        if(this.categories.find(cat => cat.id === this.product.parentCategory)
          && !this.categories.find(cat => cat.id === this.product.parentCategory).children){
          this.product.category = null
        }
        if(this.product.category){
          if(this.product.category.parent){
              this.product.parentCategory = this.product.category.parent;
          } else {
              this.product.parentCategory = this.product.category;
            this.product.category = null
          }

        }
      },
      previewImage(isList, image, forceImg = false) {
        if (!forceImg) {
          if (isList) {
            if (this.listImage && this.listImage.url) {
              return this.listImage.url
            }
          } else {
            if (this.backgroundImage && this.backgroundImage.url) {
              return this.backgroundImage.url
            }
          }
        }
      if(image){
        if (image.url) {
          return image.url;
        }
        return URL.createObjectURL(image)
      }

      },
      updateImages(){
        this.loadingButton = true;
        var formData = this.getDataImage();

        ProductService.update(this.product.id, formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Блюдо успешно обновлено';
          this.snackbarColor = 'success';

          this.init();
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении блюда';
          this.snackbarColor = 'error';
        }).finally(() => (this.loadingButton = false))
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        ProductService.update(this.product.id, formData).then(response => {
          this.product.iiko_id = response.data.iiko_id
          this.product.glovo_iiko_id = response.data.glovo_iiko_id
          this.snackbar = true;
          this.snackbarText = 'Блюдо успешно обновлено';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении блюда';
          this.snackbarColor = 'error';
        }).finally(() => (this.loadingButton = false))
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        ProductService.create(formData).then(response => {
          this.product = response.data
          this.serviceCategory();
          this.init();
          this.$router.push({ name: 'product-edit', params: { id: response.data.id } })
          this.snackbar = true;
          this.snackbarText = 'Блюдо успешно создано';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании блюда';
          this.snackbarColor = 'error';
        }).finally(() => (this.loadingButton = false))
      },
      removeProduct() {
        if (confirm('Вы уверены, что хотите удалить это блюдо?')) {
          this.loadingButton = true;
          ProductService.remove(this.id).then(response => {
            this.snackbar = true;
            this.snackbarText = 'Блюдо успешно удалено';
            this.snackbarColor = 'success';
            this.init();
          }).catch(error => {
            this.snackbar = true;
            this.snackbarText = 'Ошибка при удалении блюда';
            this.snackbarColor = 'error';
          }).finally(() => (this.loadingButton = false))
        }
      },
      restoreProduct() {
        this.loadingButton = true;
        ProductService.restore(this.id).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Блюдо успешно восстановлено';
          this.snackbarColor = 'success';
          this.init();
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при восстановлении блюда';
          this.snackbarColor = 'error';
        }).finally(() => (this.loadingButton = false))
      },
      getDataImage(){
        let formData = new FormData();
        formData.append('isUpdateImage', 1);
        if (this.id) {
          if (this.listImage && !this.listImage.url) {
            formData.append("listImage", this.listImage);
          } else if (this.listImage && this.listImage.url) {
            formData.append("listImage", this.listImage.url);
          }
          if (this.backgroundImage && !this.backgroundImage.url) {
            formData.append("backgroundImage", this.backgroundImage);
          } else if (this.backgroundImage && this.backgroundImage.url) {
            formData.append("backgroundImage", this.backgroundImage.url);
          }


          let id = 0;
          for (const item of this.additionalMainImages) {

            if (item) {
              if (!item.url) {
                formData.append("additionalMainImages[" + id + "]", item);
              } else if (item.url) {
                formData.append("additionalMainImages[" + id + "]", item.url);
              }
              id++;
            }
          }

        }

        return formData
      },
      getData() {
        let formData = new FormData();
        if (this.product.category && this.product.category.parent_group && this.product.parentCategory && this.product.category.parent_group !== this.product.parentCategory.id) {
          this.product.category = null;
        }
        let categoryId = this.product.category ? this.product.category.id :
          (this.product.parentCategory ? this.product.parentCategory.id : null);

        formData.append('name', this.product.name);
        formData.append('name_ua', this.product.name_ua);
        formData.append('slug', this.product.slug);
        formData.append('allergen', this.product.allergen);
        formData.append('allergen_ua', this.product.allergen_ua);
        formData.append('die_date', this.product.die_date);
        formData.append('die_date_ua', this.product.die_date_ua);
        formData.append('description_ua', this.product.description_ua);
        formData.append('description', this.product.description);
        formData.append('seo_h1', this.product.seo_h1);
        formData.append('seo_h1_ua', this.product.seo_h1_ua);
        formData.append('seo_title', this.product.seo_title);
        formData.append('seo_title_ua', this.product.seo_title_ua);
        formData.append('seo_description', this.product.seo_description);
        formData.append('seo_description_ua', this.product.seo_description_ua);
        formData.append('iiko_id', this.product.iiko_id);
        formData.append('code', this.product.code);
        formData.append('parent_group', categoryId);
        formData.append('workshop_id', this.product.workshop ? (this.product.workshop.id ? this.product.workshop.id : this.product.workshop) : null);
        formData.append('is_not_cashback', this.product.is_not_cashback ? 1 : 0);
        formData.append('is_show_reviews', this.product.is_show_reviews ? 1 : 0);
        formData.append('tags', this.product.tags);
        formData.append('hide', this.product.hide ? 1 : 0);
        formData.append('energy_amount', this.product.energy_amount);
        formData.append('fiber_amount', this.product.fiber_amount);
        formData.append('fat_amount', this.product.fat_amount);
        formData.append('carbohydrate_amount', this.product.carbohydrate_amount);
        formData.append('weight', this.product.weight);
        formData.append('price', this.product.price);
        formData.append('glovo_price', this.product.glovo_price);
        formData.append('glovo_iiko_id', this.product.glovo_iiko_id);
        formData.append('glovo_code', this.product.glovo_code);



        return formData
      }
    },
  }
</script>
<style lang="scss">
  .cursor-pointer:hover{
    .v-input__control{
      .v-input__slot{
        cursor: pointer!important;
      }
    }


  }
</style>

<style scoped lang="scss">

  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .product-images .v-image{
    max-height: 374px;
  }
  .modifier{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      .img{
        height: 3.541vw;
        text-align: center;
        margin-top: .83vw;
        .v-img{
          margin: 0 auto;
        }
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }

  .plus {
    background-color: #333;
    color: white;
    padding: 5px 10px;
    margin-left: 10px;
  }

  .w-full {
    width: 100%;
  }
</style>
